import React from "react";
import Modal from "react-bootstrap/Modal";

const Confirmation = (props) => {
  const { body, handleYes, title, className, ...modalProps } = props;

  return (
    <Modal
      {...modalProps}
      size="md"
      className="modal-container"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="bg-transparent">
        <Modal.Title className="text-center fw-bold fs-3 mb-1 ">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-gray-700">
          {" "}
          {body ? body : "Do you wish to duplicate this item?"}
        </p>
      </Modal.Body>
      <Modal.Footer className=" d-flex justify-content-center bg-transparent px-3 pt-3">
        <button onClick={props.onHide} className="btn btn-secondary px-5">
          No
        </button>
        <button onClick={handleYes} className="btn btn-primary px-5">
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Confirmation;
